import { STATUS_POST_MAX_CHARS, STATUS_POST_MAX_CHARS_PRIVILEGED } from './constants';

// Moderators and admins may post long statuses; the author's role decides the limit.
export function statusMaxChars(userType?: string | null): number {
  return ['moderator', 'admin'].includes(userType ?? '')
    ? STATUS_POST_MAX_CHARS_PRIVILEGED
    : STATUS_POST_MAX_CHARS;
}
